function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class MissingKeyError extends Error {
  constructor(rowIndex, columnName) {
    super("".concat(columnName, " can't be empty (on pending row ").concat(rowIndex + 1, ")"));
    _defineProperty(this, "isMissingKey", true);
    _defineProperty(this, "rowIndex", void 0);
    _defineProperty(this, "columnName", void 0);
    this.rowIndex = rowIndex;
    this.columnName = columnName;
  }
}
export default MissingKeyError;
//# sourceMappingURL=MissingKeyError.js.map